(function () {
  // Sepet sistemi kapali: sepet sayfasina gelen ana sayfaya doner
  if (/^\/cart\/?$/.test(location.pathname)) { location.replace('/'); return; }
  // Urun adlarindaki "( ... )" on eklerini ve "* ... *" notlarini gosterimde temizler
  function clean(s) {
    return s.replace(/^\s*(\([^)]*\)\s*)+/, '').replace(/\*[^*]*\*/g, '').replace(/\s{2,}/g, ' ').trim();
  }
  function run() {
    document.title = document.title.replace(/Droply/g, 'Lumière');
    document.querySelectorAll('.product__title h1,.product__title h2,.card__heading a,.card__heading,.cart-item__name,.cart-notification-product__name').forEach(function (e) {
      if (e.children.length) return;
      var t = clean(e.textContent);
      if (t && t !== e.textContent.trim()) e.textContent = t;
    });
  }
  // Kapida odeme (EasySell) butonu satir ici !important renk tasir; tema tonuna cek ve yazisini degistir
  var LBL = 'Kapıda Ödeme ile Satın Al';
  var ES = { 'background': '#2A2622', 'border-color': '#2A2622', 'border-radius': '0', 'box-shadow': 'none', 'letter-spacing': '.12em', 'font-weight': '500', 'font-size': '14px', 'min-height': '54px' };
  function es() {
    document.querySelectorAll('.es-popup-button,.es-cta-btn,.es-sticky-btn').forEach(function (b) {
      if (b.style.getPropertyValue('border-radius') !== '0px') {
        for (var k in ES) b.style.setProperty(k, ES[k], 'important');
        if (b.classList.contains('es-sticky-btn')) b.style.setProperty('box-shadow', '0 10px 30px rgba(42,38,34,.35)', 'important');
      }
      var w = document.createTreeWalker(b, NodeFilter.SHOW_TEXT), n;
      while ((n = w.nextNode())) if (/SATIN AL/i.test(n.nodeValue) && n.nodeValue.trim() !== LBL) n.nodeValue = LBL;
    });
    lock();
    hint();
  }
  // Siparis formu telefon alani: altina ornek yaz, yazarken 0532 123 45 67 (4-3-2-2) bicimine sok
  function hint() {
    var p = document.getElementById('es-phone');
    if (!p) return;
    var box = p.closest('.es-phone-container') || p.parentNode;
    var nx = box.nextElementSibling;
    if (nx && nx.className === 'lm-ph-hint') return;
    var h = document.createElement('p'); h.className = 'lm-ph-hint'; h.textContent = 'Örnek: 0532 123 45 67';
    box.parentNode.insertBefore(h, box.nextSibling);
  }
  function fmtPhone(d) {
    var g = [4, 3, 2, 2], out = [], i = 0;
    for (var k = 0; k < g.length && i < d.length; k++) { out.push(d.substr(i, g[k])); i += g[k]; }
    return out.join(' ');
  }
  var lastPh = '';
  // Yakalama asamasinda calisir: EasySell (Vue) degeri okumadan once bicimlenmis olur
  document.addEventListener('input', function (e) {
    var p = e.target;
    if (!p || p.id !== 'es-phone') return;
    var d = p.value.replace(/\D/g, '');
    if (/^905/.test(d)) d = d.slice(2);
    if (d.charAt(0) === '5') d = '0' + d;
    // Bosluk silindiyse rakam sayisi degismez; bir rakam geri sil
    if (/^delete/.test(e.inputType || '') && d === lastPh.replace(/\D/g, '') && d.length) d = d.slice(0, -1);
    d = d.slice(0, 11);
    var v = fmtPhone(d);
    lastPh = v;
    if (p.value !== v) { p.value = v; try { p.setSelectionRange(v.length, v.length); } catch (x) {} }
  }, true);
  // Siparis formu acikken arkadaki sayfa kaymasin (iPhone overflow:hidden'i dinlemez): sayfayi yerinde sabitle, kapaninca geri birak
  var lockY = null;
  function lock() {
    var m = document.getElementById('easysell-modal');
    var open = !!m && getComputedStyle(m).display !== 'none';
    var s = document.body.style;
    if (open && lockY === null) {
      lockY = window.scrollY || window.pageYOffset || 0;
      s.position = 'fixed'; s.top = -lockY + 'px'; s.left = '0'; s.right = '0'; s.width = '100%';
    } else if (!open && lockY !== null) {
      var y = lockY; lockY = null;
      s.position = ''; s.top = ''; s.left = ''; s.right = ''; s.width = '';
      try { window.scrollTo({ top: y, left: 0, behavior: 'instant' }); } catch (e) { window.scrollTo(0, y); }
    }
  }
  // Urun sayfasi (telefon): fotograf altinda nokta gostergesi + "Buyutmek icin dokunun" ipucu
  function dots() {
    var list = document.querySelector('.product__media-list');
    if (!list || document.querySelector('.lm-dots')) return;
    var items = list.querySelectorAll('.product__media-item');
    if (items.length < 2) return;
    var d = document.createElement('div'); d.className = 'lm-dots';
    for (var i = 0; i < items.length; i++) { var e = document.createElement('i'); if (!i) e.className = 'on'; d.appendChild(e); }
    var h = document.createElement('p'); h.className = 'lm-zhint'; h.textContent = 'Büyütmek için dokunun';
    var host = list.closest('slider-component') || list;
    host.parentNode.insertBefore(d, host.nextSibling); d.parentNode.insertBefore(h, d.nextSibling);
    list.addEventListener('scroll', function () {
      var n = Math.round(list.scrollLeft / Math.max(1, list.clientWidth));
      for (var j = 0; j < d.children.length; j++) d.children[j].classList.toggle('on', j === n);
    }, { passive: true });
  }
  // Urun videosu: ekranda gorundugunde sessiz, dongulu ve kendiliginden oynar; kaydirinca durur
  function vids() {
    var list = document.querySelector('.product__media-list');
    if (!list) return;
    var dms = list.querySelectorAll('deferred-media');
    if (!dms.length) return;
    function play(dm) {
      if (!dm.getAttribute('loaded') && dm.loadContent) dm.loadContent(false);
      var v = dm.querySelector('video');
      if (!v) return;
      v.muted = true; v.loop = true; v.playsInline = true; v.setAttribute('playsinline', ''); v.controls = false;
      // Dawn video yuklenirken tum medyayi durdurur; hazir olunca tekrar dene
      var go = function () { if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } };
      go(); v.addEventListener('canplay', go, { once: true }); setTimeout(go, 400); setTimeout(go, 1200);
    }
    function check() {
      var lr = list.getBoundingClientRect();
      dms.forEach(function (dm) {
        var r = dm.getBoundingClientRect(), cx = r.left + r.width / 2;
        var onScreen = cx > lr.left && cx < lr.right && r.bottom > 0 && r.top < window.innerHeight;
        if (onScreen) play(dm); else { var v = dm.querySelector('video'); if (v && !v.paused) v.pause(); }
      });
    }
    // Sayfa acilir acilmaz videoyu hazirla: kaydirinca oynat simgesi gorunmeden hemen baslasin
    dms.forEach(function (dm) {
      if (!dm.getAttribute('loaded') && dm.loadContent) dm.loadContent(false);
      var v = dm.querySelector('video');
      if (v) { v.muted = true; v.loop = true; v.playsInline = true; v.setAttribute('playsinline', ''); v.controls = false; v.preload = 'auto'; }
    });
    var t; function later() { clearTimeout(t); t = setTimeout(check, 120); }
    list.addEventListener('scroll', later, { passive: true });
    window.addEventListener('scroll', later, { passive: true });
    document.addEventListener('lm:recheck', check);
    setTimeout(check, 300);
  }
  if (document.readyState !== 'loading') { run(); dots(); vids(); } else document.addEventListener('DOMContentLoaded', function () { run(); dots(); vids(); });
  document.addEventListener('cart:updated', run);
  new MutationObserver(es).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
})();
